import { get, post } from '../apiClient';
import { API_ENDPOINTS } from '../config';

const telephonyService = {
  /**
   * Get current live calls snapshot for Live Console
   */
  getLiveCalls: async () => {
    try {
      const response = await get(API_ENDPOINTS.CRM.TELEPHONY.LIVE_CALLS);

      if (response && response.responseCode === 200) {
        const payload = response.data || {};
        return {
          success: true,
          liveCalls: payload.liveCalls || [],
          lastUpdated: payload.lastUpdated || null,
          lastError: payload.lastError || null
        };
      }

      return {
        success: false,
        liveCalls: [],
        error: response?.responseMessage || 'Failed to fetch live calls'
      };
    } catch (error) {
      return {
        success: false,
        liveCalls: [],
        error: error.message || 'Failed to fetch live calls'
      };
    }
  },

  /**
   * Get missed calls from CRM activities
   * Uses /api/crm/activities with type=call & callStatus=missed
   */
  getMissedCalls: async (params = {}) => {
    try {
      const searchParams = new URLSearchParams();
      searchParams.set('type', 'call');
      searchParams.set('callStatus', params.callStatus || 'missed');
      if (params.search) searchParams.set('search', params.search);
      if (params.startDate) searchParams.set('startDate', params.startDate);
      if (params.endDate) searchParams.set('endDate', params.endDate);
      if (params.limit) searchParams.set('limit', String(params.limit));
      if (params.page) searchParams.set('page', String(params.page));
      if (params.sortBy) searchParams.set('sortBy', params.sortBy);
      if (params.sortOrder) searchParams.set('sortOrder', params.sortOrder);

      const url = `${API_ENDPOINTS.CRM.ACTIVITIES}?${searchParams.toString()}`;
      const response = await get(url);

      if (response && response.responseCode === 200) {
        const payload = response.data || {};
        const activities = payload.activities || [];
        const pagination = payload.pagination || {};

        return {
          success: true,
          activities,
          pagination
        };
      }

      return {
        success: false,
        activities: [],
        error: response?.responseMessage || 'Failed to fetch missed calls'
      };
    } catch (error) {
      return {
        success: false,
        activities: [],
        error: error.message || 'Failed to fetch missed calls'
      };
    }
  },

  /**
   * Get call logs from CRM activities
   * Uses /api/crm/activities with type=call
   */
  getCallLogs: async (params = {}) => {
    try {
      const searchParams = new URLSearchParams();
      searchParams.set('type', 'call');
      if (params.search) searchParams.set('search', params.search);
      if (params.callStatus) searchParams.set('callStatus', params.callStatus);
      if (params.startDate) searchParams.set('startDate', params.startDate);
      if (params.endDate) searchParams.set('endDate', params.endDate);
      if (params.limit) searchParams.set('limit', String(params.limit));
      if (params.page) searchParams.set('page', String(params.page));
      if (params.sortBy) searchParams.set('sortBy', params.sortBy);
      if (params.sortOrder) searchParams.set('sortOrder', params.sortOrder);

      const url = `${API_ENDPOINTS.CRM.ACTIVITIES}?${searchParams.toString()}`;
      const response = await get(url);

      if (response && response.responseCode === 200) {
        const payload = response.data || {};
        const activities = payload.activities || [];
        const pagination = payload.pagination || {};

        return {
          success: true,
          activities,
          pagination
        };
      }

      return {
        success: false,
        activities: [],
        error: response?.responseMessage || 'Failed to fetch call logs'
      };
    } catch (error) {
      return {
        success: false,
        activities: [],
        error: error.message || 'Failed to fetch call logs'
      };
    }
  },

  /**
   * Trigger manual CDR sync from RP Digital
   */
  syncCDR: async (startDate, endDate) => {
    try {
      const response = await post(API_ENDPOINTS.CRM.TELEPHONY.SYNC_CDR, { startDate, endDate });

      if (response && response.responseCode === 200) {
        return {
          success: true,
          data: response.data,
          message: response.responseMessage
        };
      }

      return {
        success: false,
        error: response?.responseMessage || 'Failed to sync call records'
      };
    } catch (error) {
      return {
        success: false,
        error: error.message || 'Failed to sync call records'
      };
    }
  }
};

export default telephonyService;
